import helper from "./helper";

let getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters
let getRecordingUrlWithParameters = helper.getRecordingUrlWithParameters
let getWorkerUrlWithParameters = helper.getWorkerUrlWithParameters

export default {
    SELECTORS: {
        ACCOUNTS: {
            USERS: () => getAccountsUrlWithParameters(
                'users|user|fio', 'post'
            )
        },
        WORKER: {
            ALL: () => getWorkerUrlWithParameters(
                'selectors|employee|worker', 'get'
            )
        }
    }

}
